export * from './ngs-reveal.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/ng-scrollreveal/index.js
// module id = ../../../../ng-scrollreveal/index.js
// module chunks = 4